import { combineReducers } from "@reduxjs/toolkit";
import lottoReducer from "./lottoReducer";
import userReducer from "./userReducer";

const rootReducer = combineReducers ({
    lotto: lottoReducer,
    user: userReducer
});

export default rootReducer;